/* QBand · Carrossel contínuo (loop infinito) sobre rolagem nativa.
   Anda sozinho devagar, mas a pessoa pode arrastar para os dois lados.
   - Duplica os itens uma vez para emendar o fim no começo sem salto.
   - Pausa durante toque/arrasto/mouse por cima e volta 2,5 s depois.
   - Pausa fora da tela (bateria) e respeita "reduzir movimento".
   - Botão [data-qb-marquee-toggle] para pausar/reproduzir (WCAG 2.2.2).

   Marcação:
   <div data-qb-marquee data-speed="28">          ← viewport com overflow-x
     <ul data-qb-marquee-track> <li>…</li> </ul>
   </div>
   <button data-qb-marquee-toggle aria-pressed="true">…</button> */
(() => {
  if (window.qbMarqueeInit) return;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  window.qbMarqueeInit = (viewport, toggle) => {
    if (!viewport || viewport.qbMarquee) return;
    const track = viewport.querySelector('[data-qb-marquee-track]');
    const originals = [...track.children];
    if (!originals.length) return;

    // Cópia dos itens para o loop (escondida de leitores de tela e do teclado)
    originals.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
      track.appendChild(clone);
    });

    const speed = Number(viewport.dataset.speed || 28); // px por segundo
    let loopWidth = 0;
    let pos = 0;
    let last = 0;
    let raf = 0;
    let visible = false;
    let holding = false; // dedo/mouse em cima
    let resumeTimer = 0;
    let userPaused = reduce.matches;
    let selfScroll = false;
    let pageScrolling = false; // página rolando na vertical: carrossel espera
    let pageTimer = 0;

    const measure = () => {
      const first = originals[0];
      const firstClone = track.children[originals.length];
      loopWidth = firstClone.offsetLeft - first.offsetLeft;
    };

    const wrap = () => {
      if (!loopWidth) return;
      if (viewport.scrollLeft >= loopWidth) {
        selfScroll = true;
        viewport.scrollLeft -= loopWidth;
      } else if (viewport.scrollLeft <= 0) {
        selfScroll = true;
        viewport.scrollLeft += loopWidth;
      }
      pos = viewport.scrollLeft;
    };

    const running = () => visible && !holding && !userPaused && !pageScrolling;

    const tick = (now) => {
      raf = 0;
      if (!running()) return;
      const dt = last ? Math.min(now - last, 64) : 16;
      last = now;
      pos += (speed * dt) / 1000;
      if (pos >= loopWidth) pos -= loopWidth;
      selfScroll = true;
      viewport.scrollLeft = pos;
      raf = requestAnimationFrame(tick);
    };

    const start = () => {
      if (raf || !running()) return;
      last = 0;
      pos = viewport.scrollLeft;
      raf = requestAnimationFrame(tick);
    };

    const stop = () => {
      cancelAnimationFrame(raf);
      raf = 0;
    };

    const hold = () => {
      holding = true;
      clearTimeout(resumeTimer);
      stop();
    };

    const release = () => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        holding = false;
        start();
      }, 2500);
    };

    const syncToggle = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', String(!userPaused));
      toggle.classList.toggle('is-paused', userPaused);
    };

    // Rolagem feita pela pessoa: mantém o loop emendado nos dois sentidos
    viewport.addEventListener(
      'scroll',
      () => {
        if (selfScroll) {
          selfScroll = false;
          return;
        }
        wrap();
      },
      { passive: true }
    );

    viewport.addEventListener('pointerdown', hold, { passive: true });
    viewport.addEventListener('touchstart', hold, { passive: true });
    viewport.addEventListener('pointerup', release, { passive: true });
    viewport.addEventListener('touchend', release, { passive: true });
    viewport.addEventListener('pointercancel', release, { passive: true });
    viewport.addEventListener('mouseenter', hold);
    viewport.addEventListener('mouseleave', release);
    viewport.addEventListener(
      'wheel',
      (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          hold();
          release();
        }
      },
      { passive: true }
    );
    viewport.addEventListener('focusin', hold);
    viewport.addEventListener('focusout', release);

    toggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      syncToggle();
      if (userPaused) stop();
      else {
        holding = false;
        start();
      }
    });

    // Rolagem da página: pausa o carrossel para não disputar o processador (principal causa de tranco no celular)
    addEventListener(
      'scroll',
      () => {
        if (!visible) return;
        if (!pageScrolling) {
          pageScrolling = true;
          stop();
        }
        clearTimeout(pageTimer);
        pageTimer = setTimeout(() => {
          pageScrolling = false;
          start();
        }, 300);
      },
      { passive: true }
    );

    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible) start();
      else stop();
    }).observe(viewport);

    new ResizeObserver(() => {
      measure();
      wrap();
    }).observe(track);

    measure();
    syncToggle();
    viewport.qbMarquee = { start, stop };
  };

  const boot = () =>
    document.querySelectorAll('[data-qb-marquee]').forEach((el) => {
      const toggle = el.parentElement.querySelector('[data-qb-marquee-toggle]');
      window.qbMarqueeInit(el, toggle);
    });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
